import { formatPhoneNumber } from "react-phone-number-input";
import weedmap_logo from "../assets/weedmap_logo.svg";
import weedvader_logo from "../assets/weedvader_logo.svg";
import leafly_logo from "../assets/leafly_logo.svg";
import wordpress_logo from "../assets/wordpress_log.svg";
import canabis from "../assets/cannabis.svg";
import canasale_logo from "../assets/LogoWithoutText.svg";
import dayjs from "dayjs";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../config/constants";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

let activeRangeSide = null;

const Utils = {
  getFormattedDate: (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    return month + "." + day + "." + year;
  },

  decimalCount(number) {
    // Convert to String
    const numberAsString = number.toString();
    // String Contains Decimal
    if (numberAsString.includes(".")) {
      return numberAsString.split(".")[1].length;
    }
    // String Does Not Contain Decimal
    return 0;
  },

  getFormattedDateandTime: (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    let hours = date.getHours().toString().padStart(2, "0");
    let minutes = date.getMinutes().toString().padStart(2, "0");
    let seconds = date.getSeconds().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} +00:00`;
  },

  getFormattedDateTime: (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    let hours = date.getHours().toString().padStart(2, "0");
    let minutes = date.getMinutes().toString().padStart(2, "0");
    let seconds = date.getSeconds().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  },

  getMetricFormattedDate: (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  },

  getFormatedDatePromoCode: (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    return year + "-" + month + "-" + day;
  },

  convertToAmPm: (time) => {
    time = time
      ?.toString()
      ?.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time?.length > 1) {
      // If time format correct
      time = time?.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time?.join("");
  },

  parseCustomDate: (dateStr) => {
    // Replace the AM/PM and ensure it's compatible with Date
    return new Date(
      dateStr.replace(/(\d{1,2}:\d{2}:\d{2})(AM|PM)/, (_, time, period) => {
        const [hours, minutes, seconds] = time.split(":").map(Number);
        const adjustedHours =
          period === "PM" && hours < 12 ? hours + 12 : hours;
        return `${adjustedHours}:${minutes}:${seconds}`;
      })
    );
  },

  roundNumber: (number) => {
    return new Intl.NumberFormat(
      "en-US",
      { style: "currency", currency: "USD" },
      { minimumFractionDigits: 2, maximumFractionDigits: 2, currency: "USD" }
    )
      .format(number)
      .replace(/,/g, " ");
  },

  updateUrlParams: (paramKey, selectedKeys, navigate) => {
    const url = new URL(window.location);
    const params = url.searchParams;

    if (typeof selectedKeys === "string" && selectedKeys.length > 0) {
      params.set(paramKey, selectedKeys);
    } else if (selectedKeys.size > 0) {
      params.set(paramKey, Array.from(selectedKeys).join(","));
    } else {
      params.delete(paramKey);
    }
    navigate(`${url.pathname}?${params.toString()}`);
  },

  // order.discount_total arrives with an inconsistent sign depending on the
  // order source (WeedVader stores it negative, edited/Canasale/Weedmaps
  // positive) — never trust the sign, use the magnitude only. Display-only.
  getDiscountAmount: (value) => Math.abs(Number(value || 0)),

  roundNumberWithoutCurrency: (number) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(number)
      .replace(/,/g, " ");
  },

  formatHoursSmart: (hours) => {
    const h = Number(hours);
    if (!Number.isFinite(h) || h < 0) return "0 min";
    if (h < 1) {
      const minutes = Math.round(h * 60);
      return `${minutes} min`;
    }
    if (h < 24) {
      return `${h.toFixed(2)} h`;
    }
    const days = h / 24;
    return `${days.toFixed(2)} d`;
  },

  debounce: (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  },

  debouncePrice: (func, delay) => {
    let timeoutId;
    return function (index, value) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(index, value);
      }, delay);
    };
  },

  getFormatedDate: () => {
    var d = new Date();
    return (
      [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
      " " +
      [d.getHours(), d.getMinutes(), d.getSeconds()].join(":")
    );
  },

  joinDate(date) {
    function format() {
      let formatter = new Intl.DateTimeFormat("en-us");
      return formatter.format(date);
    }
    return format();
  },

  getUniqueListBy(arr, key) {
    return [
      ...new Map(
        arr.map((item, index) => [item[key] || index + "index", item])
      ).values(),
    ];
  },

  filterOption: (input, option) =>
    (option?.label ?? "")?.toLowerCase()?.includes(input?.toLowerCase()),

  deliveryStatusColorMapping: (status) => {
    switch (status) {
      case "ASSIGNED":
        return "blue";
      case "ON_THE_WAY":
        return "gold";
      case "AT_CUSTOMER":
        return "purple";
      case "DELIVERED":
        return "green";
      case "CANCELED":
        return "red";
      default:
        return "default";
    }
  },

  deliveryStatusNameMapping: (status) => {
    switch (status) {
      case "ASSIGNED":
        return "Assigned";
      case "ON_THE_WAY":
        return "On the way";
      case "AT_CUSTOMER":
        return "At customer";
      case "DELIVERED":
        return "Delivered";
      case "CANCELED":
        return "Canceled";
      default:
        return "";
    }
  },

  statusNameMapping: (status) => {
    switch (status) {
      case "IN_PROGRESS":
        return "In Progress";
      case "READY_FOR_ATTAINMENT":
        return "Finish preparing";
      case "COMPLETE":
        return "Complete";
      case "CANCELED_CUSTOMER":
        return "Canceled";
      default:
        return "";
    }
  },

  metrcStatusNameMapping: (status) => {
    switch (status) {
      case "PENDING":
        return "Pending";
      case "ERROR_SUBMISSIONS":
        return "Error Submissions";
      case "COMPLETE":
        return "Complete";
      case "NOT_SUBMITTED":
        return "Not Submitted";
      case "ACTIVE":
        return "Active";
      case "INACTIVE":
        return "Inactive";
      case "SUCCESSFUL TAGS":
        return "Successful Tags";
      case "SKIPPED TAGS":
        return "Skipped Tags";
      case "FAILED TAGS":
        return "Failed Tags";
      case "PURCHASE ORDERS":
        return "Purchase Orders";
      case "RECEIVING":
        return "Receiving";
      case "BILLS":
        return "Bills";
      case "CANCELED":
        return "Canceled";
      case "ACCEPTED":
        return "Accepted";
      default:
        return "";
    }
  },

  taxNameMapping: (key) => {
    switch (key) {
      case "total_subtotal":
        return "Total SubTotal";
      case "total_sales_tax":
        return "Total Sales Tax";
      case "total_excise_tax":
        return "Total Excise Tax";
      case "total_city_m_tax":
        return "Total City M Tax";
      case "total_city_r_tax":
        return "Total City R Tax";
      case "total_grand_total":
        return "Grand Total";
      default:
        return "";
    }
  },

  // Custom variant rows are typed by hand, so a row can carry a price with no
  // unit (or a unit with no weight). Returns `{ row, field, message }` for the
  // first such row (row = position among the custom rows, field = the empty
  // cell), or null when every row is complete or untouched.
  getCustomVariantError: (customVariants = []) => {
    const filled = (v) =>
      v !== null && v !== undefined && String(v).trim() !== "";
    for (let i = 0; i < customVariants.length; i++) {
      const { weight, unit, price } = customVariants[i] || {};
      if ((filled(price) || filled(weight)) && !filled(unit)) {
        return {
          row: i,
          field: "unit",
          message: `Custom variant ${i + 1}: choose a unit`,
        };
      }
      if (filled(unit) && filled(price) && !filled(weight)) {
        return {
          row: i,
          field: "weight",
          message: `Custom variant ${i + 1}: enter a weight`,
        };
      }
    }
    return null;
  },

  // Two priced rows of the same weight and unit ("1/2 oz" and "0.5 oz", or
  // "1 g" twice) would save as two variants of one weight (CANA-793). Rows are
  // read the way the backend reads them: a fraction or trailing zeros fold into
  // one number, a long unit name folds into its short form, and units are never
  // converted (14 g next to 1/2 oz is allowed). A row with a weight and a unit
  // is read from those, since its name is only rebuilt on save; otherwise from
  // its name. Returns `{ row, message }` for the second row of the first pair
  // (row = its index in `rows`), or null.
  getDuplicateVariantError: (rows = []) => {
    const UNITS = {
      gram: "g",
      grams: "g",
      ounce: "oz",
      ounces: "oz",
      kilogram: "kg",
      kilograms: "kg",
      milligram: "mg",
      milligrams: "mg",
      pound: "lb",
      pounds: "lb",
      units: "unit",
    };
    const filled = (v) =>
      v !== null && v !== undefined && String(v).trim() !== "";
    const toKey = (weight, unit) => {
      const text = String(weight).trim();
      const number = text.includes("/")
        ? Number(text.split("/")[0]) / Number(text.split("/")[1])
        : Number(text);
      const short = String(unit).trim().toLowerCase();
      return Number.isFinite(number) ? `${number} ${UNITS[short] || short}` : null;
    };
    const seen = {};
    for (let i = 0; i < rows.length; i++) {
      const { weight, unit, price, name } = rows[i] || {};
      // Only a row with a price is saved; price 0 is not.
      if (!(Number(price) > 0)) continue;
      const nameParts = String(name || "").trim().split(/\s+/);
      const nameKey =
        nameParts.length === 2 ? toKey(nameParts[0], nameParts[1]) : null;
      const key =
        filled(weight) && filled(unit) ? toKey(weight, unit) : nameKey;
      if (!key) continue;
      const label = nameKey === key ? name.trim() : `${weight} ${unit}`;
      if (seen[key]) {
        return {
          row: i,
          message: `"${seen[key]}" and "${label}" are the same weight (${key}). Keep only one.`,
        };
      }
      seen[key] = label;
    }
    return null;
  },

  // The backend nests cannabinoid errors under "cannabinoids"
  // ({ cannabinoids: { thc_milligrams: ["..."] } }) while the form fields are
  // flat, so lift them to the field names the Form.Items use.
  flattenMenuItemErrors: (payload) => {
    const { cannabinoids, ...rest } = payload || {};
    if (
      !payload ||
      Array.isArray(payload) ||
      !cannabinoids ||
      typeof cannabinoids !== "object" ||
      Array.isArray(cannabinoids)
    ) {
      return payload;
    }
    const fieldNames = {
      thc: "thc-percent",
      cbd: "cbd-percent",
      thc_milligrams: "thc-milligrams",
      cbd_milligrams: "cbd-milligrams",
    };
    for (const key in cannabinoids) {
      rest[fieldNames[key] || key] = cannabinoids[key];
    }
    return rest;
  },

  // A rejected menu item save is already shown under every visible form field
  // whose name is a key of the payload (the hook sets those), so the
  // notification is left with the first key that has no such field. A field
  // hidden for the current product type does not count. `product` repeats
  // `name` on a custom item and has no field of its own. Returns
  // `{ message, fieldNode }`: the notification text (null when nothing is left
  // to say) and the topmost field holding an inline error (null when there is
  // none). A payload that gives neither still returns a generic message, so a
  // failed save is never silent. The message is always text: a list of
  // messages is joined, an object is printed, a plain-string payload is kept
  // (unless it is an HTML error page).
  getMenuItemSaveError: (payload, formElement) => {
    payload = Utils.flattenMenuItemErrors(payload);
    const toText = (value) =>
      Array.isArray(value)
        ? value.map(toText).filter(Boolean).join(" ")
        : value && typeof value === "object"
          ? JSON.stringify(value)
          : value ?? "";
    const fieldNodes = {};
    let message = null;
    if (typeof payload === "string") {
      message = /^\s*</.test(payload) ? null : payload;
    } else if (Array.isArray(payload)) {
      message = payload[0] || null;
    } else if (payload && typeof payload === "object") {
      for (const key in payload) {
        const node = formElement?.querySelector(`[id="${key}"]`);
        if (node?.getClientRects().length) fieldNodes[key] = node;
      }
      const restKey = Object.keys(payload).find(
        (key) => !fieldNodes[key] && !(key === "product" && fieldNodes.name)
      );
      message = restKey ? payload[restKey] : null;
    }
    const fieldNode =
      Object.values(fieldNodes).sort(
        (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top
      )[0] || null;
    message = toText(message) || null;
    if (!message && !fieldNode) message = "Error occurred.";
    return { message, fieldNode };
  },

  menuNameMapping: (name) => {
    switch (name) {
      case "weedmaps":
        return "WeedMaps";
      case "wordpress":
        return "Wordpress";
      case "leafly":
        return "Leafly";
      case "canasale":
        return "CanaSale";
      case "shop":
        return "Shop";
      case "weedgravity":
        return "WeedGravity";
      case "drakkar":
        return "Drakkar";
      case "asaprojects":
        return "ASA Projects";
      case "weedvader":
        return "WeedVader";
      case "multivendor":
        return "Multi-Vendor";
      default:
        return name;
    }
  },

  isValidNumber: (value) => {
    if (
      typeof value === "boolean" ||
      value === null ||
      value === "" ||
      Array?.isArray(value) ||
      typeof value === "object" ||
      value === undefined
    ) {
      return false;
    }
    // Convert the value to a number
    const num = Number(value);
    if (Object.is(num, -0) || Object.is(num, 0) || value.toString() === ".0") {
      return false;
    }
    // Check if it's a valid number and matches the original value (as string or number)
    return !isNaN(num) && isFinite(num);
  },

  getUrlParamsAsObject: (searchParams) => {
    if (!searchParams) return {}; // Return empty object if searchParams is null or undefined
    return Object.fromEntries(searchParams?.entries());
  },

  get_filtered_url_params: (old_url_params, new_url_params) => {
    if (!old_url_params && !new_url_params) return {};
    const old_params_as_object = this?.getUrlParamsAsObject(old_url_params);
    const filtered_params_as_object = Object?.fromEntries(
      Object?.entries({ ...old_params_as_object, ...new_url_params })?.filter(
        ([_, value]) => Boolean(value) || value === 0
      )
    );
    return filtered_params_as_object;
  },

  generateUniqueColorHSL: (name, ids = []) => {
    // Combine name and IDs into a single string (to ensure unique key)
    const sortedIds = [...ids].sort((a, b) => a - b);
    const combinedString = `${name}-${sortedIds.join(",")}`;

    // Simple hashing function (FNV-1a) to generate a unique hash from the combined string
    let hash = 1; // FNV-1a offset basis
    for (let i = 0; i < combinedString.length; i++) {
      hash = (hash * 0x01000193) ^ combinedString.charCodeAt(i);
    }

    // Use the hash to determine hue, saturation, and lightness
    const hueStep = 360 / 30; // Spread hues over 30 segments (more segments for more variety)
    const hue = (Math.abs(hash) * hueStep) % 360; // Ensure hue stays within 0-360 range

    // Vary saturation and lightness based on the hash value, with a broader range
    const saturation = 50 + (Math.abs(hash) % 40); // Vary saturation between 50% and 90%
    const lightness = 30 + (Math.abs(hash) % 40); // Vary lightness between 30% and 70%

    // Generate the final color in HSL format (hue, saturation, lightness)
    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

    return color;
  },

  findParentCategory: (product) => {
    // MenuItem.parent_category is the authoritative FK and what the
    // backend sets during Blaze imports (e.g. Gummies, Vape Pens). DRF
    // serializes it as the bare UUID (a PrimaryKeyRelatedField), so we
    // resolve it against the nested categories M2M which carries the
    // full Category objects. The legacy "find an entry with parent ===
    // null" path only matched top-level rows, so leaves like Gummies /
    // Vape Pens rendered blank in the menu list even though parent_category
    // pointed at them correctly.
    const pc = product?.parent_category;
    if (pc) {
      if (typeof pc === "object" && pc.name) {
        return pc;
      }
      if (typeof pc === "string" && Array.isArray(product?.categories)) {
        const match = product.categories.find((c) => c?.id === pc);
        if (match) return match;
      }
    }
    return product?.categories?.length
      ? product?.categories?.find(
          (el) => el?.parent === null && el?.name?.toLowerCase() !== "featured"
        )
      : "";
  },

  mapperOfMeasurment: (unit) => {
    switch (unit) {
      case "kilograms":
        return "kg";
      case "kilogram":
        return "kg";
      case "milligrams":
        return "mg";
      case "milligram":
        return "mg";
      case "grams":
        return "g";
      case "gram":
        return "g";
      case "pounds":
        return "lb";
      case "pound":
        return "lb";
      case "ounces":
        return "oz";
      case "ounce":
        return "oz";
      default:
        return "";
    }
  },

  formatWeight: (weight) => {
    // Convert the number to a string
    const numberString = weight?.toString();

    // If the number has a decimal point, remove trailing zeros after the decimal
    if (numberString?.includes(".")) {
      return parseFloat(weight);
      // fixed by two variant parseFloat(parseFloat(weight).toFixed(2));
    }

    // If there's no decimal or it's already an integer, return the number as it is
    return weight;
  },

  showProductDetail(variant) {
    return this?.mapperOfMeasurment(variant?.unit)
      ? `${this?.formatWeight(
          variant?.name?.split(" ")[0]
        )} ${this?.mapperOfMeasurment(variant?.unit)}`?.replace(/\s+/g, "")
      : `${this?.formatWeight(variant?.name?.split(" ")[0])} ${
          variant?.unit
        }`?.replace(/\s+/g, "");
  },

  saleValidator: (_, value) => {
    return new Promise((resolve, reject) => {
      if (
        value !== "" &&
        value !== undefined &&
        !/^\d+(\.\d{1,2})?$/?.test(value)
      ) {
        reject(
          "Input must be a positive numeric value with no more than 2 decimal places."
        );
      } else if (parseFloat(value) < 0 || parseFloat(value) >= 100) {
        reject("Input must be greater than or equal to 0 and less than 100.");
      } else {
        resolve();
      }
    });
  },

  scrollIntoViewByClassName: (className) => {
    if (
      typeof className === "string" &&
      className &&
      className?.includes(".")
    ) {
      const element = document?.querySelector(className); // Select the form
      if (element) {
        element?.scrollIntoView({ behavior: "smooth" });
      }
    }
  },

  format_phone_number: (phone_number) => {
    return phone_number ? formatPhoneNumber(phone_number) : "";
  },

  // Categories are imported from several vendors with no unique name, so the
  // API can return the same name many times. Selects key options by name, so
  // keep the first row per name.
  uniqueByName: (list) => {
    const seen = new Set();
    return (list || []).filter((el) => {
      if (seen.has(el?.name)) return false;
      seen.add(el?.name);
      return true;
    });
  },

  transformToTreeSelectData: function transformToTreeData(data) {
    return data?.map((item) => ({
      value: item?.name,
      title: item?.name,
      ...(item?.subcategories?.length > 0 && {
        children: transformToTreeData(item?.subcategories),
      }),
    }));
  },

  decideDiscountType: (type) => {
    if (type?.toLowerCase() === "percentage") {
      return `%`;
    } else {
      return `$`;
    }
  },

  menuImageMapping: (name) => {
    switch (name) {
      case "weedmaps":
        return weedmap_logo;
      case "weedvader":
        return weedvader_logo;
      case "leafly":
        return leafly_logo;
      case "wordpress":
        return wordpress_logo;
      case "canasale":
        return canasale_logo;
      // case "shop":
      //   return canasale_logo;
      default:
        return canabis;
    }
  },

  getSources: () => {
    return [
      {
        label: "CanaSale",
        value: "CANASALE",
      },
      {
        label: "WeedVader",
        value: "WEEDVADER",
      },
      {
        label: "WeedMaps",
        value: "WEEDMAPS",
      },
      {
        label: "WeedGravity",
        value: "WEED_GRAVITY",
      },
      {
        label: "Shop",
        value: "SHOP",
      },
      {
        label: "Drakkar",
        value: "DRAKKAR",
      },
      {
        label: "Wordpress",
        value: "WORDPRESS",
      },
      {
        label: "Leafly",
        value: "LEAFLY",
      },
      {
        label: "ASA Projects",
        value: "ASAPROJECTS",
      },
    ];
  },

  formatDuration: (seconds) => {
    if (!Utils.isValidNumber(seconds)) return "00:00:00";

    const totalSeconds = Math.round(seconds);
    const dur = dayjs.duration(totalSeconds, "seconds");

    const days = dur.days();
    const hours = dur.hours();
    const minutes = dur.minutes();
    const secs = dur.seconds();

    // Pad numbers with leading zeros
    const padZero = (num) => num?.toString()?.padStart(2, "0");

    if (days > 0) {
      return `${days}d ${padZero(hours)}:${padZero(minutes)}:${padZero(secs)}`;
    } else if (hours > 0) {
      return `${padZero(hours)}:${padZero(minutes)}:${padZero(secs)}`;
    } else {
      return `${padZero(minutes)}:${padZero(secs)}`;
    }
  },

  capitalizeFirstLetter: (str) => {
    if (typeof str !== "string" || !str) return str;
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
  },

  capitalizeErrorMessages: (obj) => {
    if (!obj) return obj;

    // Handle string directly
    if (typeof obj === "string") {
      return Utils?.capitalizeFirstLetter(obj);
    }

    // Handle non-object types
    if (typeof obj !== "object") return obj;

    const capitalize = (value) => {
      if (typeof value === "string") {
        return Utils?.capitalizeFirstLetter(value);
      } else if (Array.isArray(value)) {
        return value?.map((item) =>
          typeof item === "string" ? Utils?.capitalizeFirstLetter(item) : item
        );
      } else if (typeof value === "object" && value !== null) {
        return Utils?.capitalizeErrorMessages(value);
      }
      return value;
    };

    const result = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = capitalize(obj[key]);
      }
    }
    return result;
  },

  // The reserved badge has two independent causes and each needs a different
  // action from the operator, so each chip carries its own tooltip.
  // kind: "bags" (held on the shelf for a driver's bag) | "office" (short — restock).
  getReservedTooltip: (kind) => {
    if (kind === "bags") {
      return "On the shelf, but promised to a driver's bag — move it into the bag before delivery. Click to see the orders.";
    }
    return "Promised to customers but the office doesn't have it. Restock or transfer stock, or the order can't be completed. Click to see the orders.";
  },

  validateColumnDeselection: (
    selectedColumns,
    notificationFn = null,
    defaultColumns = []
  ) => {
    const minColumns = 3;
    if (selectedColumns?.length <= minColumns + defaultColumns?.length) {
      if (notificationFn && typeof notificationFn === "function") {
        notificationFn(
          "warning",
          "Minimum Columns Required",
          `You must keep at least ${minColumns} columns selected.`
        );
      }
      return false;
    }
    return true;
  },

  disableFutureDates: (current) => {
    return current && current > dayjs()?.endOf("day");
  },

  disableFutureAndReversedDates: (current, info) => {
    if (current && current > dayjs()?.endOf("day")) return true;
    if (info?.from && current && current.isBefore(info.from, "day"))
      return true;
    return false;
  },

  disableReversedDates: (current, info) => {
    if (info?.from && current && current.isBefore(info.from, "day"))
      return true;
    return false;
  },

  // antd gives disabledDate no start/end info (`info.type` is the calendar
  // mode), so the focused side is tracked via `onFocus={Utils.trackRangeSide}`.
  // Only one picker is open at a time, so one module-level value is enough.
  trackRangeSide: (_event, info) => {
    activeRangeSide = info?.range;
  },

  // Disables End dates before the range's start, and Start dates after the
  // range's end. `info.from` is the start picked in this session; when only End
  // is edited it is empty, so fall back to the saved start (`value`, or a getter
  // for form-controlled pickers). Editing Start is checked against the saved end.
  disableReversedDatesFor:
    (value, { noFuture = false } = {}) =>
    (current, info) => {
      if (noFuture && current && current > dayjs()?.endOf("day")) return true;
      const saved = typeof value === "function" ? value() : value;
      if (activeRangeSide === "start") {
        const end = saved?.[1];
        return !!(end && current && current.isAfter(end, "day"));
      }
      if (activeRangeSide !== "end") return false;
      const start = info?.from ?? saved?.[0];
      return !!(start && current && current.isBefore(start, "day"));
    },

  disabledRangeTime: (current, type, info) => {
    const from = info?.from;
    if (!from || !current || !current.isSame(from, "day")) return {};
    const range = (start, end) => {
      const out = [];
      for (let i = start; i < end; i += 1) out.push(i);
      return out;
    };
    if (type === "end") {
      return {
        disabledHours: () => range(0, from.hour()),
        disabledMinutes: (h) => (h === from.hour() ? range(0, from.minute()) : []),
        disabledSeconds: (h, m) =>
          h === from.hour() && m === from.minute()
            ? range(0, from.second())
            : [],
      };
    }
    return {
      disabledHours: () => range(from.hour() + 1, 24),
      disabledMinutes: (h) =>
        h === from.hour() ? range(from.minute() + 1, 60) : [],
      disabledSeconds: (h, m) =>
        h === from.hour() && m === from.minute()
          ? range(from.second() + 1, 60)
          : [],
    };
  },

  parsePrice: (price) => {
    if (price === null || price === undefined || price === "") {
      return 0;
    }
    const parsed =
      typeof price === "string" ? parseFloat(price) : Number(price);
    return isNaN(parsed) || !isFinite(parsed) ? 0 : parsed;
  },
  
  isSalePriceValid: (salePrice, regularPrice) => {
    const sale = Utils?.parsePrice(salePrice);
    const regular = Utils?.parsePrice(regularPrice);
    // Sale price must be greater than 0 and less than regular price
    return sale > 0 && regular > 0 && sale < regular;
  },

  getDisplayDate: (dateString) => {
    if (!dateString) return "";
    return dayjs(dateString).format(DATE_FORMAT);
  },

  getDisplayDateTime: (dateString) => {
    if (!dateString) return "";
    return dayjs(dateString).format(DATE_TIME_FORMAT);
  },

  getPaymentTypeLabel: (key, options) => {
    if (!key) return "";
    if (Array.isArray(options)) {
      const match = options?.find(
        (opt) => opt?.key?.toLowerCase?.() === String(key)?.toLowerCase()
      );
      if (match?.label) return match.label;
    }
    return String(key)
      ?.split("_")
      ?.map((part) =>
        part?.length
          ? part[0]?.toUpperCase() + part?.slice(1)?.toLowerCase()
          : ""
      )
      ?.join(" ");
  },
};

// Order sources whose customer app has a chat with the store. Everything else
// (Weedmaps, Blaze, Weed Gravity, walk-ins) gets a 400 from /messages/.
export const CHAT_SOURCES = ["weedvader", "shop"];

export default Utils;
